import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

export type AppVariant = 'full';

interface AppVariantContextType {
  variant: AppVariant;
}

const AppVariantContext = createContext<AppVariantContextType | undefined>(undefined);

interface AppVariantProviderProps {
  children: ReactNode;
  variant: AppVariant;
}

export function AppVariantProvider({ children, variant }: AppVariantProviderProps) {
  return <AppVariantContext.Provider value={{ variant }}>{children}</AppVariantContext.Provider>;
}

// eslint-disable-next-line react-refresh/only-export-components
export function useAppVariant(): AppVariantContextType {
  const context = useContext(AppVariantContext);
  if (!context) {
    throw new Error('useAppVariant must be used within an AppVariantProvider');
  }
  return context;
}
